export const SUBSCRIPTION_STATUS = {
  ACCOUNT_CREATED: 'account_created',
  FREE_TRIAL_STARTED: 'free_trial_started',
  FREE_TRIAL_COMPLETED: 'free_trial_completed',
  FREE_TRIAL_EXPIRED: 'free_trial_expired',
  PRESCRIPTION_ACTIVE: 'prescription_active'
}